import _ from 'lodash';

import './offices.scss';


/* @ngInject */
export default function officesController($scope, $stateParams, UserData, ModalService, HPRoles) {
    const vm = this;

    vm.isEditingOffice = false;


    vm.addOffice = () => {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/offices/addOffice/addOffice.html',
            windowClass: 'add-office full-screen',
            controller: 'AddOfficeController',
            controllerAs: 'addOffice',
            size: 'full-screen',
        });

        modal.result.then((result) => {
            if (result === true) {
                $scope.$broadcast('refreshOffices');
            }
            ModalService.closeLgModal();
        });
    };

    function initializeEditMode() {
        if ($stateParams.accountId !== null) {
            vm.isEditingOffice = true;
        } else {
            vm.isEditingOffice = false;
        }
    }

    function getUserSettings() {
        UserData.getUserData().then((response) => {
            const currentRole = _.find(HPRoles, (key, other) => other === response.Roles[0]);
            vm.canAddOffices = !!currentRole && currentRole.rank === 1;
            initializeEditMode();
        });
    }


    function init() {
        getUserSettings();
    }


    init();
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/officesController.js